import React from 'react';
import { openProposalWindow } from '../services/proposal-generator';

function formatCurrency(value) {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '0.00';
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function EstimateViewer({ estimate, project, onExportPDF }) {
  if (!estimate) return <div>No estimate data</div>;

  return (
    <div className="estimate-viewer">
      <div className="estimate-header">
        <h2>Project Estimate</h2>
        <div className="estimate-meta">
          <p><strong>Project:</strong> {project?.name || estimate?.projectName || 'Unknown'}</p>
          <p><strong>Location:</strong> {project?.location || estimate?.projectLocation || '-'}</p>
          <p><strong>Date:</strong> {new Date(estimate.createdDate).toLocaleDateString()}</p>
        </div>
      </div>

      <div className="estimate-summary">
        <h3>Cost Summary</h3>
        <div className="summary-grid">
          <div className="summary-item">
            <span className="label">Labor</span>
            <span className="value">${formatCurrency(estimate.summary.laborCosts)}</span>
          </div>
          <div className="summary-item">
            <span className="label">Materials</span>
            <span className="value">${formatCurrency(estimate.summary.materialCosts)}</span>
          </div>
          <div className="summary-item">
            <span className="label">Overhead ({estimate.summary.overheadPercent || 40}%)</span>
            <span className="value">${formatCurrency(estimate.summary.overhead)}</span>
          </div>
          <div className="summary-item highlight">
            <span className="label">Profit ({estimate.summary.profitPercent || 15}%)</span>
            <span className="value">${formatCurrency(estimate.summary.profit)}</span>
          </div>
          <div className="summary-item total">
            <span className="label">Total Estimate</span>
            <span className="value">${formatCurrency(estimate.summary.estimateTotal)}</span>
          </div>
        </div>
      </div>

      <div className="estimate-by-trade">
        <h3>Breakdown by Trade</h3>
        <table className="trade-table">
          <thead>
            <tr>
              <th>Trade</th>
              <th>Items</th>
              <th>Total Cost</th>
              <th>% of Total</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(estimate.summary.byTrade || {}).map(([trade, data]) => {
              const percent = ((data.total / parseFloat(estimate.summary.estimateTotal)) * 100).toFixed(1);
              return (
                <tr key={trade}>
                  <td>{trade}</td>
                  <td>{data.items}</td>
                  <td>${formatCurrency(data.total.toString())}</td>
                  <td>{percent}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="line-items">
        <h3>Line Items ({estimate.lineItems?.length || 0} items)</h3>
        <table className="items-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Description</th>
              <th>Qty</th>
              <th>Unit</th>
              <th>Unit Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {estimate.lineItems && estimate.lineItems.map((item) => (
              <tr key={item.itemNumber}>
                <td>{item.itemNumber}</td>
                <td>{item.description}</td>
                <td>{item.quantity}</td>
                <td>{item.unit}</td>
                <td>${formatCurrency(item.unitPrice.toString())}</td>
                <td>${formatCurrency(item.total.toString())}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="estimate-actions">
        <button className="btn btn-primary" onClick={() => openProposalWindow(estimate)}>
          View Professional Proposal
        </button>
        <button className="btn btn-secondary" onClick={onExportPDF}>
          Export as PDF
        </button>
      </div>
    </div>
  );
}

export default EstimateViewer;
